import WrapperContext from "./wrapper-context.js";

class ShallowCallbackWrapperContext extends WrapperContext {
    constructor(callbacks) {
        super();

        this._callbacks = callbacks;

        this._objectWrapper = new WeakMap();
        this._wrapperObject = new WeakMap();

        const ctx = this;

        this._proxyHandler = {
            deleteProperty(object, key) {
                return ctx._propDelete(object, key);
            },

            set(object, key, value, receiver) {
                return ctx._propSet(object, key, value);
            },
        };
    }

    getWrapper(object) {
        if (this._wrapperObject.has(object)) {
            return object;
        }

        return this._objectWrapper.get(object) || this._createWrapper(object);
    }

    _createWrapper(object) {
        const wrapper = new Proxy(object, this._proxyHandler);
        this._objectWrapper.set(object, wrapper);
        this._wrapperObject.set(wrapper, object);
        return wrapper;
    }

    _propDelete(object, key) {
        const wrapper = this._objectWrapper.get(object);
        const oldValue = object[key];
        delete object[key];
        this._callbacks.delete(wrapper, key, oldValue);
        return true;
    }

    _propSet(object, key, newValue) {
        const wrapper = this._objectWrapper.get(object);
        const oldValue = object[key];
        object[key] = newValue;
        this._callbacks.set(wrapper, key, oldValue, newValue);
        return true;
    }
}

export default ShallowCallbackWrapperContext;
